import React from 'react'
import { MenuLink } from '../../../core/until'
import { translate } from '../../../core'
import { Badge, Space } from 'antd'
import { useQuery } from '@apollo/client'
import { GetNewTicketCountQuery } from '../graphql/ticket.graphql'
import { ShowIf } from '../../../core/component'
import { MoneyCollectOutlined } from '@ant-design/icons'

export const useNewTicketCount = () => {
  const {data} = useQuery(GetNewTicketCountQuery)
  return {newTicketCount: data?.ticketsNewCount ?? 0}
}

export const TicketMenuItem = () => {
  const {newTicketCount} = useNewTicketCount()

  return (
    <Space>
      <MenuLink
        title={translate('tickets')}
        to='/tickets'
      />
      <ShowIf
        condition={!!newTicketCount}
        replacement={<></>}
      >
        <Badge count={newTicketCount} color='#f5222d'/>
      </ShowIf>
    </Space>
  )
}

export const TicketMenuIcon = () => {
  const {newTicketCount} = useNewTicketCount()

  return (
    <>
      {newTicketCount > 0 ? (
        <MoneyCollectOutlined style={{fontSize: 23, color: "#f5222d"}}/>
      ) : (
        <MoneyCollectOutlined style={{fontSize: 23, color: "#a3bde3"}}/>
      )}
    </>
  )
}

